import { render, staticRenderFns } from "./magnify.vue?vue&type=template&id=0d346aab&scoped=true&"
var script = {}
import style0 from "./magnify.vue?vue&type=style&index=0&id=0d346aab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d346aab",
  null
  
)

export default component.exports